module.exports = __webpack_public_path__ + "static/media/排骨便當.587e1d46.jpg";